var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchPulse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m65.77,43.96c-2.94,12.91-14.48,22.54-28.28,22.54s-25.34-9.63-28.28-22.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.07,31.73c2.68-13.25,14.39-23.23,28.43-23.23s25.75,9.98,28.43,23.23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.51,38.06h18.05c.74,0,1.39-.63,1.63-1.56l3.47-13.51c.35-1.37,1.8-1.39,2.17-.03l7.99,29.08c.37,1.33,1.77,1.35,2.15.03l3.66-12.54c.26-.89.9-1.47,1.61-1.47h17.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchPulse);
export default __webpack_public_path__ + "static/media/__Switch - Pulse.669100e0bdede70778a1729b8a43a835.svg";
export { ForwardRef as ReactComponent };